import type { ServiceLanguage } from "@albertine/i18n";
import type { Tag } from "@albertine/types";
import { translation } from "../package/albertine-i18n/components";

export function tagDisplayName(tag: Tag, serviceLanguage: ServiceLanguage): string {
    return translation(`tags.${tag}`, {
        lng: serviceLanguage,
    });
}
